module.exports = __webpack_public_path__ + "img/BI看板.efe8e9b0.png";